var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 31.125C21.4688 31.6875 20.4375 31.6875 19.875 31.125L14.625 25.875C14.0625 25.3125 14.0625 24.2812 14.625 23.7188C15.1875 23.1562 16.2188 23.1562 16.7812 23.7188L21 27.9375L30.375 18.4688C30.9375 17.9062 31.9688 17.9062 32.5312 18.4688C33.0938 19.0312 33.0938 20.0625 32.5312 20.625L22.0312 31.125ZM32.1562 4.3125C35.25 3.75 38.5312 4.6875 40.9688 7.03125C43.3125 9.46875 44.25 12.75 43.6875 15.8438C46.2188 17.625 48 20.625 48 24C48 27.4688 46.2188 30.375 43.6875 32.25C44.25 35.3438 43.3125 38.625 40.9688 40.9688C38.5312 43.4062 35.25 44.3438 32.1562 43.7812C30.375 46.3125 27.375 48 24 48C20.5312 48 17.5312 46.3125 15.75 43.7812C12.6562 44.3438 9.375 43.4062 6.9375 40.9688C4.59375 38.625 3.65625 35.3438 4.21875 32.25C1.6875 30.375 0 27.4688 0 24C0 20.625 1.6875 17.625 4.21875 15.8438C3.65625 12.75 4.59375 9.46875 6.9375 7.03125C9.375 4.6875 12.6562 3.75 15.75 4.3125C17.5312 1.78125 20.5312 0 23.9062 0C27.375 0 30.375 1.78125 32.1562 4.3125ZM17.25 7.875L16.0312 7.5C13.6875 6.75 10.9688 7.3125 9.09375 9.1875C7.21875 11.0625 6.65625 13.7812 7.40625 16.125L7.78125 17.3438L6.65625 17.9062C4.40625 19.0312 3 21.375 3 24C3 26.7188 4.40625 28.9688 6.65625 30.1875L7.78125 30.75L7.40625 31.9688C6.65625 34.3125 7.21875 37.0312 9.09375 38.9062C10.9688 40.7812 13.6875 41.3438 16.0312 40.5938L17.25 40.2188L17.8125 41.3438C19.0312 43.5938 21.2812 45 24 45C26.625 45 28.875 43.5938 30.0938 41.3438L30.6562 40.2188L31.875 40.5938C34.2188 41.3438 36.9375 40.7812 38.8125 38.9062C40.6875 37.0312 41.25 34.3125 40.5 31.9688L40.125 30.75L41.25 30.1875C43.5 28.9688 45 26.7188 45 24C45 21.375 43.5 19.0312 41.25 17.9062L40.125 17.3438L40.5 16.125C41.25 13.7812 40.6875 11.0625 38.8125 9.1875C36.9375 7.3125 34.2188 6.75 31.875 7.5L30.6562 7.875L30.0938 6.75C28.875 4.5 26.625 3 24 3C21.2812 3 19.0312 4.5 17.8125 6.75L17.25 7.875Z",
    fill: "url(#paint0_linear_651_12386)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_651_12386",
    x1: 0,
    y1: 23.9974,
    x2: 48,
    y2: 23.9974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFCA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFC148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFB20F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8de021c564511f0dcf9003adbe769259.svg";
export { ForwardRef as ReactComponent };